import { render } from "./ClinicCreateTab.vue?vue&type=template&id=bbdfacd4&scoped=true"
import script from "./ClinicCreateTab.vue?vue&type=script&lang=js"
export * from "./ClinicCreateTab.vue?vue&type=script&lang=js"

import "./ClinicCreateTab.vue?vue&type=style&index=0&id=bbdfacd4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdfacd4"]])

export default __exports__